import React, { useEffect, useState } from "react";
import Link from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import konekMobIcon from "../../images/icon-konek.png";
import NotDisplayPWA from './NotDisplayPWA';
import CheckOS from './CheckOS';
import { withCookies, Cookies } from 'react-cookie';
import * as cookie from '../../scripts/CookiesAppGo';


const useStyles = makeStyles((theme) => ({
    close: {
        padding: theme.spacing(0.5),
    },
    imgLogo: {
        width: '50px',
        height: '50px',
        marginRight: '10px'
    },
    linkInstall: {
        textAlign: 'center'
    },
    popInstallPWA: {
        bottom: '50px !important'
    }
}));

const InstallPWA = (props) => {
    const [neverDisplay, setNeverDisplay] = React.useState(false);
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [state, setState] = React.useState({
        open: true,
        vertical: 'bottom',
        horizontal: 'center',
    });

    const { vertical, horizontal, open } = state;

    const { cookies } = props;

    const { isDesktop } = CheckOS();

    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const classes = useStyles();


    useEffect(() => {
        setNeverDisplay(cookies.get(cookie.pwa_never_display) === 'true');

        const handler = e => {
            e.preventDefault();
            //console.log("we are being triggered :D");
            setSupportsPWA(true);
            setState({ ...state, open: true });
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        window.addEventListener("load", () => {
            let trackText;
            if (navigator && navigator.standalone) {
                trackText = "Launched: Installed (iOS)";
                setState({ ...state, open: false });
            } else if (matchMedia("(display-mode: standalone)").matches) {
                trackText = "Launched: Installed";
                setState({ ...state, open: false });
            } else {
                trackText = "Launched: Browser Tab";
            }
            //console.log(trackText);
        });

        window.addEventListener("appinstalled", event => {
            setState({ ...state, open: false });
            //console.log('app installed');
        });

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    const onClick = evt => {
        evt.preventDefault();
        if (!promptInstall) {
            return;
        }
        promptInstall.prompt();
    };

    const handleOpenInstaller = () => {
        cookies.set(cookie.pwa_never_display, false, { path: '/' });
        setNeverDisplay(false);
        setState({ ...state, open: true });
    }

    if (!supportsPWA || isDesktop) {
        return null;
    }

    if (neverDisplay || !state.open) {
        return (
            <div className={classes.linkInstall}>
                <Link
                    component="button"
                    variant="body2"
                    onClick={handleOpenInstaller}
                    className={classes.link}
                >
                    {i18next.t("installPwa:install")} KoneK Mobile
                </Link>
            </div>
            );
    }

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={open}
                onClose={handleClose}
                className={classes.popInstallPWA}
                message={
                    <React.Fragment>
                        <div style={{ maxWidth: "400px" }}>
                            <div style={{ float: 'left' }}>
                                <Button color="inherit" size="small" onClick={onClick}>
                                    <img
                                        src={konekMobIcon}
                                        className={classes.imgLogo}
                                    />

                                    {i18next.t("installPwa:install")}
                                </Button>
                                <div className={classes.description}>
                                    <span>{i18next.t('installPwa:description-ios')}</span>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>

                }
                action={
                    <React.Fragment>
                        <NotDisplayPWA />
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            className={classes.close}
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </IconButton>
                    </React.Fragment>
                }
                key={vertical + horizontal}
            />
        </div>
    );
};

export default withNamespaces(['installPwa'], { wait: true })(withCookies(InstallPWA));